import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

// import RadiusedButton from '../RadiusedButton'

import burgerIcon from '../../resources/images/burger-ico.svg'
import bottomGradient from '../../resources/images/burger-menu-gradient.svg'
import topGradient from '../../resources/images/burger-menu-top-gradient.svg'

import {
	StyledOverlay,
	StyledOverlayContent,
	StyledCloseButton,
	StyledBurgerContainer,
	StyledTopContainer,
	// StyledButton,
	StyledBlogLink,
	StyledBottomImage,
	StyledTopImage
} from './BurgerMenuStyle'
const BurgerMenu = () => {
	const [overlay, setOverlay] = useState(false)
	const { t } = useTranslation()

	const onLinkClick = eventName => {
		if (typeof window !== 'undefined') {
			if (eventName === 'features') {
				window.scrollTo(0, 1550)
				setOverlay(!overlay)
			} else if (eventName === 'pricing') {
				window.scrollTo(0, 3700)
				setOverlay(!overlay)
			}
		}
	}

	const handleChange = () => {
		setOverlay(!overlay)
	}

	return (
		<>
			<StyledOverlay overlay={overlay}>
				<StyledCloseButton onClick={handleChange} />
				<StyledOverlayContent>
					<StyledBottomImage src={bottomGradient} loading={'lazy'} alt='' />
					<StyledTopImage src={topGradient} loading={'lazy'} alt='' />
					<StyledTopContainer>
						<StyledBlogLink onClick={() => handleChange()} to='/liveness-and-age'>
							{t('LivenessCheckTitleHeader')}
						</StyledBlogLink>
						<StyledBlogLink onClick={() => handleChange()} to='/document-verification'>
							{t('DocumentTitleHeader')}
						</StyledBlogLink>
						{/* <StyledBlogLink onClick={() => handleChange()} to='/electronic-signature'>
							{t('ESignatureTitleHeader')}
						</StyledBlogLink> */}
						<StyledBlogLink onClick={() => onLinkClick('features')} to='/'>
							{t('Features')}
						</StyledBlogLink>
						{/* <StyledBlogLink onClick={() => onLinkClick('pricing')} to='/pricing'>
							{t('SeePricing')}
						</StyledBlogLink> */}
						<StyledBlogLink onClick={() => handleChange()} to='/blog'>
							{t('blog')}
						</StyledBlogLink>
						<StyledBlogLink to='https://kvalifika.gitbook.io/kvalifika-1/initial-setup/setup' target='blank'>
							{t('initialSetup')}
						</StyledBlogLink>
						<StyledBlogLink to='https://github.com/kvalifika/' target='blank'>
							{t('mobileSDKs')}
						</StyledBlogLink>
						<StyledBlogLink to='https://kvalifika.gitbook.io/kvalifika-1/' target='blank'>
							{t('kvalifikaDocs')}
						</StyledBlogLink>
						<StyledBlogLink to='https://github.com/Kvalifika/kvalifika-web-sdk' target='blank'>
							{t('apiReference')}
						</StyledBlogLink>
					</StyledTopContainer>
					{/* <StyledButton>
						<RadiusedButton value={'tryForFree'} hrefValue={'https://www.admin.kyc.ge/signup'} />
					</StyledButton> */}
				</StyledOverlayContent>
			</StyledOverlay>
			<StyledBurgerContainer onClick={handleChange}>
				<img src={burgerIcon} alt='' />
			</StyledBurgerContainer>
		</>
	)
}

export default BurgerMenu
